module.exports = __webpack_public_path__ + "img/mastercard.cdaba15c.png";